export default {
  pageSize: {
    id: 'bo_sellers-opportunities-number_of_opportunities',
    defaultMessage: 'Number of opportunities',
  },
}
